import Accordion from './Accordion.vue';

export default Accordion;



// WEBPACK FOOTER //
// ./src/pages/profile/components/accordion/index.ts